import axios from "fetch-api/fetch-api";
import { IModelByMake } from "../interfaces/garage-apis";

export function getModelsByMake(make: string) {
  return axios.get<IModelByMake[]>("/get-models-by-make-v3", {
    params: {
      make,
    },
  });
}
